import { Component, OnInit } from '@angular/core';
import { slideToTop } from '../../router-animation/router-animation.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MatDialog } from '@angular/material';
import { DialogComponent } from 'src/app/dialog.component';
import { Location } from '@angular/common';
//import { LeadAddFollowupModelComponent } from '../lead-add-followup-model/lead-add-followup-model.component';
import {  sessionStorage} from 'src/app/localstorage.service';
// import { ChangeEnquiryStatusComponent } from '../change-enquiry-sta.tus/change-enquiry-status.component';
import * as moment from 'moment';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ChangeEnquiryStatusComponent } from 'src/app/lead/change-enquiry-status/change-enquiry-status.component';
import { LeadAddFollowupModelComponent } from 'src/app/lead/lead-add-followup-model/lead-add-followup-model.component';
import { SiteAddFollowupComponent } from '../site-add-followup/site-add-followup.component';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html',
  styleUrls: ['./site-detail.component.scss']
})
export class SiteDetailComponent implements OnInit {

  exp_loader:any=false;
  tabType:any ='Profile';
  fabBtnValue:any = 'status'
  lead_id: any;
  active: any = {};
  data: any = {};
  type:any;
  lead_detail: any = [];
  filter: any = {};
  loader: boolean = false;
  tabActiveType: any = {};
  data_not_found:boolean = false;
  followup_list: any = [];
  userData: any;
  userId: any;
  userName: any;
  login_data:any={};
  login_data5: any = {};
  add: any = {};
  lead_logs:any=[]
  dr_id:any;
  url:any='';
  sr_no:any=0;
  total_page:any;
  pageCount:any;
  page_limit: any;
  pagenumber:any =1;
  start: any = 0;
  minDate:any;
  site_detail: any = [];
  site_id: any;
  site_logs: any = [];
  site_products: any = [];
  checkinData: any = [];
  checkinLoader:any=false;
  today_date:any;
  
  constructor(
    public route: ActivatedRoute,
    public serve: DatabaseService,
    public router: Router,
    public dialog: MatDialog,
    public session: sessionStorage,
    public alert: DialogComponent,
    public toast:ToastrManager,
    private _location: Location,) {
      this.url = serve.uploadUrl+'site/';
      this.page_limit = serve.pageLimit;
      this.login_data = this.session.getSession();
      this.login_data = this.login_data.value;
      this.login_data5 = this.login_data.data;
      this.login_data = this.login_data.assignModule;
      this.minDate = new Date();
      const index = this.login_data.findIndex(row => row.module_name == 'Lead Distributors');
     
      this.route.params.subscribe(params => {
        this.site_id = params.id;
        this.serve.currentUserID = params.id
      });
    
      this.leadDetail();
      this.userData = JSON.parse(localStorage.getItem('st_user'));
      this.userId=this.userData['data']['id'];
      this.userName=this.userData['data']['name'];
      this.tabActive('tab1');
    }
    
    backToList() {
      this._location.back();
    }
    
    tabActive(tab: any) {
      this.tabActiveType = {};
      this.tabActiveType[tab] = true;
    }
    
    
    ngOnInit() {
    }
    
    goToImage(image) {
      const dialogRef = this.dialog.open(ImageModuleComponent, {
          panelClass: 'Image-modal',
          data: {
              'image': image,
              'type': 'base64'
          }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
      
  }
    
    pervious(){
      this.start = this.start - this.page_limit;
      this.followupList();
    }
    
    nextPage(){
      this.start = this.start + this.page_limit;
      this.followupList();
    }
    
    
    refresh(){
      this.filter = {};
      this.followupList();
    }
    
    leadDetail()
    {
      this.loader = true;
      this.serve.post_rqst({'id': this.site_id }, "Enquiry/getSiteDetail").subscribe(result => {
        if(result['statusCode'] == 200){
          this.site_detail = result['enquiry_detail'];
          this.site_logs = result['enquiry_detail']['log'];
          this.site_products = result['enquiry_detail']['products'];

          setTimeout(() => {
            this.loader = false;
          }, 700);
        }
        else{
          this.toast.errorToastr(result['statusMsg']);
          this.loader = false;
        }
      })
    }
    
    
    openDialog(from,type,id,ownerName, created_by_name ) {
      const dialogRef = this.dialog.open(SiteAddFollowupComponent, {
        width: '500px',
        panelClass:'cs-modal',
        data: {
          id,
          created_by_name,
          ownerName,
          type,
          'user_id':this.site_detail.user_id,
          from
        }
  
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result != false){
          this.leadDetail();
          this.followupList();
        }
      });
    }
    
    followupList() {
      this.loader = true;
      if(this.pagenumber > this.total_page){
        this.pagenumber = this.total_page;
        this.start = this.pageCount - this.page_limit;
      }
      if(this.start<0){
        this.start=0;
      }
      
      
      if(this.filter.date_created)
      {
        this.filter.date_created=moment(this.filter.date_created).format('YYYY-MM-DD');
      }
      if(this.filter.next_follow_date)
      {
        this.filter.next_follow_date=moment(this.filter.next_follow_date).format('YYYY-MM-DD');
      }
      this.serve.post_rqst({ 'filter':this.filter, 'start': this.start,'pagelimit': this.page_limit,  'dr_id':this.site_id, 'dr_type':5, 'dr_type_name':'Site'}, "Enquiry/sitefollowupList").subscribe(result => {
        if(result['statusCode'] == 200){
          this.followup_list = result['result'];
          this.loader = false;
          this.pageCount = result['count'];
          if(this.pagenumber > this.total_page){
            this.pagenumber = this.total_page;
            this.start = this.pageCount - this.page_limit;
          }
          else{
            this.pagenumber = Math.ceil(this.start/this.page_limit)+1;
          }
          this.total_page = Math.ceil(this.pageCount/this.page_limit);
          this.sr_no = this.pagenumber - 1;
          this.sr_no = this.sr_no * this.page_limit
          
          if (this.followup_list.length == 0) {
            this.data_not_found = true;
          } else {
            this.data_not_found = false;
          }
          
        }
        else{
          this.toast.errorToastr(result['statusMsg']);
          this.loader = false;
        }
        
      }, error=>{
      })
    }

    date_format(tabType): void {
      if (this.filter.date_created ) {
          
          this.filter.date_created = moment(this.filter.date_created).format('YYYY-MM-DD');
      }
    }

    getCheckin() {
            
      this.checkinLoader = true;
      if (this.pagenumber > this.total_page) {
          this.pagenumber = this.total_page;
          this.start = this.pageCount - this.page_limit;
      }
      
      if (this.start < 0) {
          this.start = 0;
      }
      let payLoad = { "filter": this.filter, "id": this.site_id, 'start': this.start, 'pagelimit': this.page_limit }
      this.serve.post_rqst(payLoad, "Enquiry/drSiteList").subscribe((result) => {
          if (result['statusCode'] == 200) {
              this.checkinData = result['dr_site_list'];
              this.pageCount = result['count'];
              if (this.pagenumber > this.total_page) {
                  this.pagenumber = this.total_page;
                  this.start = this.pageCount - this.page_limit;
              }
              else {
                  this.pagenumber = Math.ceil(this.start / this.page_limit) + 1;
              }
              this.total_page = Math.ceil(this.pageCount / this.page_limit);
              this.sr_no = this.pagenumber - 1;
              this.sr_no = this.sr_no * this.page_limit;
              this.checkinLoader = false;
          } else {
              this.checkinLoader = false;
              this.toast.errorToastr(result['statusMsg'])
          }
      });
  }
    
    // changeStatus() {
    //   const dialogRef = this.dialog.open(ChangeEnquiryStatusComponent, {
    //     width: '600px',
    //     panelClass:'cs-modal',
    //     data:{
    //       'id': this.lead_id,
    //       'user_employee_code':this.lead_detail.user_employee_code,
    //       'user_id':this.lead_detail.user_id,
    //       'user_name':this.lead_detail.user_name,
    //       'dr_type':this.lead_detail.type
    //     }
    //   });
    //   dialogRef.afterClosed().subscribe(result => {
    //     if(result != false){
    //       this.leadDetail();
    //       this.followupList();
    //     }
    //   });
    // }
    lastBtnValue(value){
      this.fabBtnValue = value;
    }  
  }
  